import { render } from "./JavaDocFilePage.vue?vue&type=template&id=2bfd231a"
import script from "./JavaDocFilePage.vue?vue&type=script&lang=js"
export * from "./JavaDocFilePage.vue?vue&type=script&lang=js"

import "./JavaDocFilePage.vue?vue&type=style&index=0&id=2bfd231a&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__